import { useEffect, useState, useRef } from 'react';
import styled from '@emotion/styled';
import DownloadIcon from '@mui/icons-material/Download';
import { CSVLink } from 'react-csv';
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';

const Root = styled('div')(() => ({
  '& a': {
    textDecoration: 'none',
    color: 'white',
  },
}));

interface ISyncProps {
  data: string[][];
  text?: string;
}

const Hidden = styled('div')`
  & a {
    visibility: hidden;
  }
`;

interface ISyncProps {
  data: string[][];
  text?: string;
}

export function CsvSyncButton(props: ISyncProps) {
  const { text = 'Download CSV', data } = props;
  return (
    <Button variant="contained">
      <Root>
        <CSVLink data={data} filename="sample.csv" className="btn btn-primary" target="_blank">
          {text}
        </CSVLink>
      </Root>
    </Button>
  );
}

interface IASyncProps {
  onLoadData: () => Promise<string[][]>;
  text?: string;
  fileName?: string;
}

export function CsvAsyncButton(props: IASyncProps) {
  const linkRef = useRef<CSVLink & HTMLAnchorElement & { link: HTMLAnchorElement }>(null); // setup the ref that we'll use for the hidden CsvLink click once we've updated the data

  const { onLoadData, text, fileName } = props;
  const [loading, setLoading] = useState(false);

  const [initiateDownload, setInitiateDownload] = useState(false);
  const [csvRows, setCsvRows] = useState<string[][]>([]);

  const fetchCsvData = async () => {
    setLoading(true);
    const response = await onLoadData();
    setCsvRows(response);
    setLoading(false);
  };

  useEffect(() => {
    if (csvRows.length) {
      setInitiateDownload(true);
      if (linkRef.current) {
        linkRef.current?.link?.click();
      }
    }
  }, [csvRows]);

  useEffect(() => {
    // Enables user to download data more than once
    if (initiateDownload) {
      setInitiateDownload(false);
    }
  }, [initiateDownload]);

  return (
    <>
      <LoadingButton
        onClick={fetchCsvData}
        loading={loading}
        loadingPosition="start"
        startIcon={<DownloadIcon />}
        variant="contained"
      >
        {text}
      </LoadingButton>

      <Hidden>
        <CSVLink
          ref={linkRef}
          data={csvRows}
          filename={fileName || 'downloaded.csv'}
          target="_blank"
        />
      </Hidden>
    </>
  );
}
